// @flow
import React, { Component } from 'react';
import OrderOfferTemplateContainer from 'containers/order/OrderOfferTemplateContainer';

type Props = {};

class OrderOffer extends Component<Props> {
  render() {
    return <OrderOfferTemplateContainer />;
  }
}

export default OrderOffer;



// WEBPACK FOOTER //
// ./src/pages/OrderOffer.js